/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { ReactComponent as SvgViewDocuments } from "components/widgets/training/view-documents.svg";
import ChildTraining from "components/widgets/training/ToBeCompletedTraining";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { showModal } from "actions";
import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import TrainingDetailDocuments from "./TrainingDetailDocuments";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { Dropdown } from "react-bootstrap";
import { LANGUAGE_CODES, LANGUAGES } from "./../../../util/constant";

import { ReactComponent as UKFlag } from "components/widgets/language/flag-united-kingdom.svg";
import { ReactComponent as UAEFlag } from "components/widgets/language/flag-united-arab-emirates.svg";
import { ReactComponent as FRFlag } from "components/widgets/language/flag-france.svg";
import { ReactComponent as DEFlag } from "components/widgets/language/flag-germany.svg";
import { ReactComponent as RUFlag } from "components/widgets/language/flag-russia.svg";
import { ReactComponent as ESFlag } from "components/widgets/language/flag-spain.svg";
import { ReactComponent as TRFlag } from "components/widgets/language/flag-turkey.svg";
import { ReactComponent as HRFlag } from "components/widgets/language/flag-croatian.svg";

class ToBeCompletedTraining extends Component {
  rowClassName = "";

  state = {
    showingChildren: true,
    selectedTrainingLanguage: null,
  };

  constructor(props) {
    super(props);
    this.trainingNameRef1 = React.createRef();
    this.trainingNameRef2 = React.createRef();
  }

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  showDetail = (t, parentId) => {
    //ELearning ise açılmasın
    if (t.trainingMethod.value === 1) return;

    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "",
      modalContent: (
        <TrainingDetailModal
          training={t}
          trainingType="toBeCompleted"
          isParent={t.isParent}
          parentId={parentId}
        />
      ),
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  showDocumentsModal = (t) => {
    // Eğitim Dökümanları = 10517
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: i18n.t("10517"),
      modalContent: <TrainingDetailDocuments trainingId={t.training.id} />,
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (type, dateString) => {
    //1 = ELearning
    if (type !== 1)
      return (
        <>
          {this.renderDate(dateString)}
          <br />
          {this.renderTime(dateString)}
        </>
      );
    else return this.renderDate(dateString);
  };

  renderTrainingMethodIcon = (value, isParent) => {
    if (isParent) {
      let icon = "iconmford fo-icon-add";
      if (!this.state.showingChildren) icon = "iconmford fo-icon-remove";
      return (
        <td
          onClick={() => this.toggleChildren()}
          className="showGrup openCloseBtn"
          style={{
            textAlign: "left",
            color: "rgb(45, 150, 205)",
            paddingLeft: "25px",
            fontSize: "20px",
          }}
        >
          <span className={icon}></span>
        </td>
      );
    } else {
      switch (value) {
        case 1:
          return (
            <td onClick={() => this.toggleChildren()}>
              <span className="iconmford fo-icon-live-tv"></span>
            </td>
          );
        case 3:
          return (
            <td onClick={() => this.toggleChildren()} className="showGrup">
              <span className="iconmford fo-icon-tv ">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </span>
            </td>
          );
        default:
          return (
            <td
              onClick={() => this.toggleChildren()} // onClick={() => this.showDetail(this.props.t, this.props.parentId)}
            >
              <span className="iconmford fo-icon-class "></span>
            </td>
          );
      }
    }
  };

  renderQuota(t) {
    //1 = ELearning
    if (t.trainingMethod.value === 1)
      return <Trans desc="Limitsiz">10512</Trans>;
    else {
      if (t.timeplans !== null && t.timeplans.length > 0)
        return `${t.timeplans[0].availableQuota}/${t.timeplans[0].quota}`;
      else return null;
    }
  }

  renderChildren = (t) => {
    if (t.isParent && this.state.showingChildren === false) {
      let childTrainings = t.childTrainings.map((ct) => {
        return (
          <React.Fragment key={ct.training.id}>
            <DesktopBreakpoint>
              <ChildTraining
                key={ct.training.id}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </DesktopBreakpoint>
            <TabletBreakpoint>
              <ChildTraining
                key={ct.training.id}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </TabletBreakpoint>
          </React.Fragment>
        );
      });
      return (
        <>
          <DesktopBreakpoint>
            <tr>
              <td colSpan="10">
                <table width="100%">
                  <tbody>
                    <tr className="child">
                      <td className="child">
                        <table className="table">
                          <tbody>{childTrainings}</tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </DesktopBreakpoint>
          <TabletBreakpoint>
            <tr>
              <td colSpan="2" className="accordionArea">
                <div className="accordion" id="accordionDays">
                  {childTrainings}
                </div>
              </td>
            </tr>
          </TabletBreakpoint>
        </>
      );
    }
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return (
        <tr className="child">
          <td className="child" colspan="2">
            <table>
              <tbody>
                <tr>
                  <td></td>
                  <td>{this.renderLanguageVersions(t)}</td>
                </tr>
                <tr data-dt-row="0" data-dt-column="2">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Yer">10016</Trans>
                    </div>
                  </td>
                  <td>{t.trainingLocation ?? ""}</td>
                </tr>
                <tr data-dt-row="0" data-dt-column="5">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Kontenjan">10162</Trans>
                    </div>
                  </td>
                  <td>{this.renderQuota(t)}</td>
                </tr>
                <tr data-dt-row="0" data-dt-column="3">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Süre">10017</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? `${t.timeplans[0].duration}`
                      : null}
                    <sup>
                      <Trans desc="GÜN">10388</Trans>
                    </sup>
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="6">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10020</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].startDate
                      )
                      : null}
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="7">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10021</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].endDate
                      )
                      : null}
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="8">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Dokumanlar">10178</Trans>
                    </div>
                  </td>
                  <td className="u-centered">{this.renderDocumentIcon(t)}</td>
                </tr>
                <tr data-dt-row="0" data-dt-column="9">
                  <td>
                    <div className="tableTitle">{/* Talep */}</div>
                  </td>
                  <td>{this.renderContinueAction(t)}</td>
                </tr>
                {this.renderChildren(t)}
              </tbody>
            </table>
          </td>
        </tr>
      );
    } else return null;
  };

  renderDocumentIcon = (t) => {
    if (!t.hasDocument) return null;

    return (
      <SvgViewDocuments
        onClick={() => this.showDocumentsModal(t)}
        className="training-table__icon-viewdoc"
      />
    );
  };

  renderContinueAction = (training) => {
    if (training.isFLC) {
      return (
        <a
          className="btn-redirect"
          href={training.starsUrl ?? "#"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Trans desc="Yönlendir">10543</Trans>
        </a>
      );
    } else {
      return (
        <a
          href="#"
          className="talepEtBtn"
          onClick={() => this.showDetail(training, this.props.parentId)}
        >
          <Trans desc="Talep Et">10377</Trans>{" "}
          <span className="icon-icon-table-request"></span>
        </a>
      );
    }
  };

  renderTrainingName = (t) => {
    let lang = localStorage.getItem("i18nextLng");
    let trainingName = "";

    if (lang === LANGUAGES.Turkish) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Turkish
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.English) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.English
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Arabic) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Arabic
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.French) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.French
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.German) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.German
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Russian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Russian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Spanish) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Spanish
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Croatian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Croatian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Italian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Italian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else {
      trainingName = t.training.name;
    }

    return <>{trainingName}</>;
  };

  renderLanguageVersions = (t) => {
    if (t.languageVersions === null || t.languageVersions.length === 0) {
      return (
        <Dropdown>
          <Dropdown.Toggle size="sm" variant="">
            <React.Fragment>
              <UKFlag className="img-fluid flag" /> EN
            </React.Fragment>
          </Dropdown.Toggle>
        </Dropdown>
      );
    }

    return (
      <Dropdown>
        <Dropdown.Toggle size="sm" variant="">
          {this.state.selectedTrainingLanguage && (
            <React.Fragment>
              {this.getFlag(this.state.selectedTrainingLanguage.value)}{" "}
              {this.state.selectedTrainingLanguage.label}
            </React.Fragment>
          )}
          {!this.state.selectedTrainingLanguage && (
            <React.Fragment>
              <UKFlag className="img-fluid flag" /> EN
            </React.Fragment>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {t.languageVersions.map((item) => (
            <Dropdown.Item
              key={t.key + item.languageVersionId}
              eventKey={item.languageCode.value}
              onSelect={(key, obj) => {
                if (this.trainingNameRef1.current)
                  this.trainingNameRef1.current.innerHTML = item.trainingName;
                if (this.trainingNameRef2.current)
                  this.trainingNameRef2.current.innerHTML = item.trainingName;

                this.setState({
                  selectedTrainingLanguage: item.languageCode,
                });
              }}
            >
              {this.getFlag(item.languageCode.value)} {item.languageCode.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  getFlag = (languageCode) => {
    switch (languageCode) {
      case LANGUAGE_CODES.English:
        return <UKFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Arabic:
        return <UAEFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.French:
        return <FRFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.German:
        return <DEFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Russian:
        return <RUFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Spanish:
        return <ESFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Turkish:
        return <TRFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Croatian:
        return <HRFlag className="img-fluid flag" />;
      default:
        return null;
    }
  };

  render() {
    const { t, isChild } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr className="grupEgitim" key={t.id}>
            {this.renderTrainingMethodIcon(t.trainingMethod.value, t.isParent)}
            <td
              className="showGrup"
              onClick={() => this.showDetail(t, this.props.parentId)}
              ref={this.trainingNameRef1}
            >
              {this.renderTrainingName(t)}
            </td>
            <td>{this.renderLanguageVersions(t)}</td>
            <td className="showGrup">{t.trainingLocation ?? ""}</td>
            <td className="showGrup">{this.renderQuota(t)}</td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? `${t.timeplans[0].duration}`
                : null}
              <sup>
                <Trans desc="GÜN">10388</Trans>
              </sup>
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].startDate
                )
                : null}
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].endDate
                )
                : null}
            </td>
            <td className="showGrup">{this.renderDocumentIcon(t)}</td>
            <td>{this.renderContinueAction(t)}</td>
            <td></td>
          </tr>
          {this.renderChildren(t)}
        </DesktopBreakpoint>
        <TabletBreakpoint>
          {isChild ? (
            <div
              key={t.training.id}
              className="card"
              style={{ marginBottom: "0" }}
            >
              <div className="card-header">
                <a className="btn btn-link" type="button">
                  <h2 className="mb-0">{t.training.name}</h2>
                </a>
              </div>
            </div>
          ) : (
            <tr key={t.training.id} className={this.rowClassName}>
              {this.renderTrainingMethodIcon(
                t.trainingMethod.value,
                t.isParent
              )}
              <td
                onClick={() => this.showDetail(t, this.props.parentId)}
                className="showGrup"
                ref={this.trainingNameRef2}
              >
                {this.renderTrainingName(t)}
              </td>
            </tr>
          )}
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal })(ToBeCompletedTraining);
